import { render, staticRenderFns } from "./haibao.vue?vue&type=template&id=ae3c3232&scoped=true"
import script from "./haibao.vue?vue&type=script&lang=js"
export * from "./haibao.vue?vue&type=script&lang=js"
import style0 from "./haibao.vue?vue&type=style&index=0&id=ae3c3232&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae3c3232",
  null
  
)

export default component.exports